module.exports = __webpack_public_path__ + "static/WEDDING E&M-498-779e26d44df7fdd28374872708cc8137.jpg";